import { useState } from 'react';

import { ApplicationError } from 'types/errorHandling';

import { useApplicationErrorHandling } from './useApplicationErrorHandling';
import useToaster from './useToaster';

const useClipboard = () => {
  // #region DATA
  const [pastedText, setPastedText] = useState('');
  const { addToaster } = useToaster();
  const handleAppErr = useApplicationErrorHandling();
  // endregion

  // #region CALLBACKS
  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setPastedText(text);
      addToaster({
        message: 'Successfully copied to clipboard',
      });
    } catch (err) {
      handleAppErr(new ApplicationError('Failed to copy', 'Failed to copy'));
    }
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setPastedText(text);
      return text;
    } catch (err) {
      handleAppErr(new ApplicationError('Failed to paste', 'Failed to paste'));
      return '';
    }
  };
  // endregion

  return {
    handleCopy,
    pastedText,
    handlePaste,
  };
};

export default useClipboard;
